export const NAME_MIN_LENGTH = 2;
export const NAME_MAX_LENGTH = 50;
